window.PDUPSELL = window.PDUPSELL || {};

(function () {
  async function refreshCartSections() {
    const sections = ["cart-drawer", "cart-icon-bubble", "header", "main-cart-items"];
    const url = `${window.location.pathname}?sections=${sections.join(",")}`;

    try {
      const res = await fetch(url);
      const data = await res.json();

      if (data["cart-drawer"]) {
        const drawer = document.querySelector('[data-section-type="cart-drawer"]');
        if (drawer) {
          const tmp = document.createElement("div");
          tmp.innerHTML = data["cart-drawer"];
          const newDrawer = tmp.querySelector('[data-section-type="cart-drawer"]');
          if (newDrawer) drawer.innerHTML = newDrawer.innerHTML;
        }
      }

      if (data["cart-icon-bubble"]) {
        const bubble = document.querySelector(".cart-count-bubble, [data-cart-count]");
        if (bubble) {
          const tmp = document.createElement("div");
          tmp.innerHTML = data["cart-icon-bubble"];
          const newBubble = tmp.querySelector(".cart-count-bubble, [data-cart-count]");
          if (newBubble) bubble.innerHTML = newBubble.innerHTML;
        }
      }

      if (data["header"]) {
        const header = document.querySelector("header");
        if (header) {
          const tmp = document.createElement("div");
          tmp.innerHTML = data["header"];
          const newHeader = tmp.querySelector("header");
          if (newHeader) header.innerHTML = newHeader.innerHTML;
        }
      }

      if (data["main-cart-items"]) {
        const main = document.querySelector("#main-cart-items");
        if (main) {
          const tmp = document.createElement("div");
          tmp.innerHTML = data["main-cart-items"];
          const newMain = tmp.querySelector("#main-cart-items");
          if (newMain) main.innerHTML = newMain.innerHTML;
        }
      }
    } catch (err) {
      console.error("refreshCartSections error:", err);
    }
  }

  async function fetchCart() {
    const res = await fetch("/cart.js", {
      method: "GET",
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    });
    return await res.json();
  }

  function normalizeVariantId(v) {
    const n = Number(v);
    return Number.isFinite(n) && n > 0 ? n : null;
  }

  function getUpsellVariantIds(popups) {
    return popups
      .map((p) => normalizeVariantId(p.dataset.variant))
      .filter(Boolean);
  }

  function cartHasAnyOfVariants(cart, variantIds) {
    if (!cart || !Array.isArray(cart.items) || !variantIds.length) return false;
    const set = new Set(variantIds.map(Number));
    return cart.items.some((it) => set.has(Number(it.variant_id)));
  }

  window.PDUPSELL.refreshCartSections = refreshCartSections;

  document.addEventListener("DOMContentLoaded", function () {
    const popups = Array.from(document.querySelectorAll(".pd-cart-upsell-popup"));
    if (!popups.length) return;

    const upsellVariantIds = getUpsellVariantIds(popups);

    // --- CLOSE helper for any popup ---
    function wireClose(popup) {
      function closeUpsell() {
        popup.style.display = "none";
        document.dispatchEvent(new CustomEvent("pd:upsell-closed"));
      }

      const closeBtn = popup.querySelector(".pd-upsell-close");
      const declineBtn = popup.querySelector(".pd-upsell-decline");
      if (closeBtn) closeBtn.onclick = closeUpsell;
      if (declineBtn) declineBtn.onclick = closeUpsell;
    }

    // --- ADD TO CART helper for any popup ---
    function wireAdd(popup, variantId) {
      const addBtn = popup.querySelector(".pd-upsell-add");
      if (!addBtn) return;

      addBtn.onclick = async () => {
        await fetch("/cart/add.js", {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
        });

        // Hide + disable ALL upsells once one is accepted (and also because it is now in cart)
        popups.forEach((p) => {
          p.style.display = "none";
          p.dataset.disabled = "true";
        });

        // Mark as seen in session to avoid any flicker in this session
        sessionStorage.setItem("pd_upsell_seen", "true");

        await refreshCartSections();
        document.dispatchEvent(new CustomEvent("pd:upsell-closed"));
      };
    }

    // Pre-wire close buttons once
    popups.forEach((p) => wireClose(p));

    async function showUpsellOnce() {
      // Already shown in session
      if (sessionStorage.getItem("pd_upsell_seen") === "true") return;

      let cart;
      try {
        cart = await fetchCart();
      } catch (e) {
        console.error("fetchCart error:", e);
        return;
      }

      // ✅ GLOBAL RULE:
      // If ANY upsell variant is already in cart -> never show any upsell popup
      if (cartHasAnyOfVariants(cart, upsellVariantIds)) {
        popups.forEach((p) => (p.dataset.disabled = "true"));
        sessionStorage.setItem("pd_upsell_seen", "true");
        return;
      }

      // Eligible popups based on initial liquid disable + valid variant
      const eligible = popups.filter((p) => p.dataset.disabled !== "true" && normalizeVariantId(p.dataset.variant));
      if (!eligible.length) return;

      // Pick random from eligible
      const popup = eligible[Math.floor(Math.random() * eligible.length)];
      const variantId = normalizeVariantId(popup.dataset.variant);
      const delay = parseInt(popup.dataset.delay, 10) || 3000;

      // Wire add button for the chosen popup
      wireAdd(popup, variantId);

      setTimeout(async () => {
        if (sessionStorage.getItem("pd_upsell_seen") === "true") return;

        // Re-check cart right before showing
        let cartBeforeShow;
        try {
          cartBeforeShow = await fetchCart();
        } catch (e) {
          console.error("fetchCart error:", e);
          return;
        }

        if (cartHasAnyOfVariants(cartBeforeShow, upsellVariantIds)) {
          popups.forEach((p) => (p.dataset.disabled = "true"));
          sessionStorage.setItem("pd_upsell_seen", "true");
          return;
        }

        popup.style.display = "flex";
        sessionStorage.setItem("pd_upsell_seen", "true");
      }, delay);
    }

    // Gift → upsell flow trigger
    document.addEventListener("pd:start-upsell", () => {
      showUpsellOnce();
    });
  });
})();
